export default {
	index:() => import( /* webpackChunkName: "index" */ '../../views/feedBack/index.vue'),
	feedback:() => import( /* webpackChunkName: "index" */ '../../views/feedBack/feedback.vue'),
	success:() => import( /* webpackChunkName: "index" */ '../../views/feedBack/success.vue'),
}